import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

export const i18nReady = i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .use({
    type: 'backend',
    read: (lng: string, _ns: string, cb: (error: Error | null, resources: object | null) => void) => {
      import(`./locales/${lng}.json`)
        .then((module) => cb(null, module.default))
        .catch((error) => cb(error, null));
    },
  })
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'fr'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

